// hooks/useStorageListener.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useStorageListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleStorageChange = (event) => {

      if (event.key === 'persist:auth' && event.newValue) {
        try {

          const newAuthState = JSON.parse(event.newValue);

          if (newAuthState.isAuthenticated === "false" || newAuthState.token === null) {
            dispatch({ type: 'LOGOUT' });
          }
        } catch (error) {
          console.error('Error parsing storage event:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch]);
};